import { render, staticRenderFns } from "./SelectGroupLevelItem.vue?vue&type=template&id=2b3420d2&scoped=true&"
import script from "./SelectGroupLevelItem.vue?vue&type=script&lang=js&"
export * from "./SelectGroupLevelItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3420d2",
  null
  
)

export default component.exports